import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'isp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./scss/app.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
